<template>
  <div class="searchBar">
    <slot> </slot>
  </div>
</template>

<script>
export default {
  name: "SearchBar"
};
</script>
<style>
.searchBar {
  margin: 0px 0px 10px 0px;
  /*padding: 10px 10px ;*/
  /*background-color: #f7f7f7;*/
  text-align: right;
}
</style>
